<template>
  <div class="form-control">
    <template v-if="!isEdit">
      <slot></slot>
      <a
        href="javascript:void(0);"
        @click="isEdit = true"
        v-if="$store.getters.getPackage == 'premium' "
      >
        <span :style="{ color: dark ? 'black' : '' }" class="fas fa-pencil-alt"></span>
      </a>
    </template>
    <template v-else>
      <template v-if="type == 'text'">
        <input
          style="color: black !important"
          type="text"
          class="form-control"
          :placeholder="placeholder"
          v-model="customer_value"
          maxlength="600"
        />
      </template>
      <template v-if="type == 'number'">
        <input
          type="number"
          @keypress="onlyNumber"
          class="form-control"
          :placeholder="placeholder"
          v-model="customer_value"
          maxlength="600"
        />
      </template>
      <template v-else-if="type == 'dropdown'">
        <multiselect
          v-model="customer_value"
          :options="options"
          :searchable="false"
          :allow-empty="false"
          selectLabel
          selectedLabel
          deselect-label
        >
        </multiselect>
      </template>
      <template v-else-if="type == 'date'">
        <v-dialog
          ref="dialog"
          v-model="showDate"
          :return-value.sync="customer_value"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <input
              type="text"
              class="form-control"
              :placeholder="placeholder"
              v-model="customer_value"
              v-on="on"
              readonly
              maxlength="600"
            />
          </template>
          <v-date-picker v-model="customer_value" scrollable color="primary">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="showDate = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog.save(customer_value)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </template>
      <div class="text-xs-center">
        <v-btn outline :color="dark ? 'white' : 'grey'" small @click="cancelEdit">{{
          $t('cancel')
        }}</v-btn>
        <v-btn depressed color="primary" small @click="saveEdit">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  props: {
    options: {
      default: () => [],
    },

    value: {
      default: undefined,
    },
    userid: {
      default: undefined,
    },
    placeholder: {
      default: '',
    },
    type: {
      default: 'text',
    },
    dark: {
      default: false,
    },
  },
  components: {
    Multiselect,
  },
  data: function () {
    return {
      showDate: false,
      isEdit: false,
      customer_value: '',
    }
  },
  mounted: function () {
    if (this.type == 'date') {
      this.customer_value = this.value
        ? moment(this.value).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    } else {
      this.customer_value = this.value
    }
    this.cached_customer_value = this.customer_value
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  methods: {
    onlyNumber(event) {
      var result = event.charCode >= 48 && event.charCode <= 57
      if (result) {
        // return result;
      } else {
        event.preventDefault()
      }
    },
    cancelEdit: function () {
      this.isEdit = false
      this.customer_value = this.cached_customer_value
    },
    saveEdit: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.userid,
        customer_value: vm.customer_value,
        onEdit: function () {
          vm.isEdit = false
          vm.cached_customer_value = vm.customer_value
          vm.$emit('input', vm.customer_value)
        },
      }
      vm.$emit('onEdit', data)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/EditCustomerValue.vue